module.exports = __webpack_public_path__ + "img/two2Red.7b8fa60d.jpg";